const PATH = 'fe.components.calibrations.calibration_tags';

const messages = {
  infant: {
    key: `${PATH}.infant`,
    defaultValue: 'Infant'
  },
  toddler: {
    key: `${PATH}.toddler`,
    defaultValue: 'Toddler'
  },
  infantToddler: {
    key: `${PATH}.infant_toddler`,
    defaultValue: 'Infant-Toddler'
  },
  preK: {
    key: `${PATH}.pre_k`,
    defaultValue: 'Pre-K'
  },
  k3: {
    key: `${PATH}.k3`,
    defaultValue: 'K–3'
  },
  preK3rd: {
    key: `${PATH}.pre_k_3rd`,
    defaultValue: 'Pre-K–3rd'
  },
  preKK: {
    key: `${PATH}.pre_k_k`,
    defaultValue: 'Pre-K/K'
  },
  upperElementary: {
    key: `${PATH}.upper_elementary`,
    defaultValue: 'Upper Elementary'
  },
  secondary: {
    key: `${PATH}.secondary`,
    defaultValue: 'Secondary'
  }
};

export default messages;
